<template>
  <div class="footer">
    <div class="detailMsg">
      <div class="nav">
        <div class="title">{{ $t('footer.map') }}</div>
        <ul>
          <li>
            <router-link :to="{ path: '/home' }">{{
              $t('head.home')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/aboutUs' }">{{
              $t('aboutUs.about_us')
            }}</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/product/main' }">{{
              $t('product.product')
            }}</router-link>
          </li>
          <!-- <li>
            <router-link :to="{ path: '/product/main' }">{{
              $t('product.new_product')
            }}</router-link>
          </li> -->
          <li>
            <router-link :to="{ path: '/newsInfo' }">{{
              $t('news.News_and_Information')
            }}</router-link>
          </li>
        </ul>
      </div>
      <div class="contact">
        <!-- <div class="title">{{ $t('footer.contact_information') }}</div>
        <ul>
          <li>{{ $t('footer.name') }}</li>
          <li>{{ $t('footer.address') }}</li>
          <li>{{ $t('footer.phone') }}</li>
          <li>{{ $t('footer.fax') }}</li>
          <li>{{ $t('footer.email') }}</li>
        </ul> -->
        <div class="title">{{ $t('footer.contact_information') }}</div>
        <ul>
          <li>
            {{ contact.length > 0 && contact[0].title }}
          </li>
          <li>
            {{ contact.length > 0 && contact[1].title }}
            {{ lang == 'zh-CN' ? '：' : ':' }}
            {{ contact.length > 0 && contact[1].displayContent }}
          </li>
          <li>
            {{ contact.length > 0 && contact[2].title }}
            {{ lang == 'zh-CN' ? '：' : ':' }}
            {{ contact.length > 0 && contact[2].displayContent }}
          </li>
          <li>
            {{ contact.length > 0 && contact[3].title }}
            {{ lang == 'zh-CN' ? '：' : ':' }}
            {{ contact.length > 0 && contact[3].displayContent }}
          </li>
          <li>
            {{ contact.length > 0 && contact[4].title }}
            {{ lang == 'zh-CN' ? '：' : ':' }}
            {{ contact.length > 0 && contact[4].displayContent }}
          </li>
        </ul>
      </div>
      <div class="info">
        <div class="wx">
          <img src="../../assets/images/footer/TASI.png" alt="" />
          <div>{{ $t('footer.WeChat_official_account') }}</div>
        </div>
        <div class="msg">
          <img src="../../assets/images/footer/01.png" />
          <img src="../../assets/images/footer/02.png" />
          <img src="../../assets/images/footer/03.png" />
          <!-- <img src="../../assets/images/footer/04.png" />
          <img src="../../assets/images/footer/05.png" /> -->
          <img src="../../assets/images/footer/06.png" />
        </div>
      </div>
    </div>
    <div class="toPrivacyPolicy">
      <!-- <router-link :to="{ path: '/privacyPolicy' }">隐私设置</router-link>
      &nbsp;&nbsp;
      <router-link :to="{ path: '/technicalSupport' }"> 技术支持 </router-link> -->
      <!-- &nbsp;&nbsp; -->
      <a @click="toAppDown"> {{ $t('footer.App_Download') }} </a>&nbsp;&nbsp;
      <a @click="toUpperDown"> {{ $t('footer.Upper_computer_download') }} </a>
    </div>
  </div>
</template>

<script>
import { GetContentSetting } from '@/http/home';

export default {
  data() {
    return {
      identifierList: ['12e57ed522ee175e450d0894837c41eb'],
      contact: [],
      lang: localStorage.getItem('web_tasi_lang') || 'zh-CN',
    };
  },
  methods: {
    async GetContentSetting() {
      const res = await GetContentSetting(this.identifierList);
      this.contact = res.data.settingMap['12e57ed522ee175e450d0894837c41eb'];
      console.log(this.contact);
    },
    toAppDown() {
      window.open(
        this.$router.resolve({
          path: '/appDown',
        }).href,
        '_blank'
      );
    },
    toUpperDown() {
      window.open(
        this.$router.resolve({
          path: '/upperDown',
        }).href,
        '_blank'
      );
    },
  },
  mounted() {
    this.GetContentSetting();
  },
};
</script>

<style scoped lang="less">
@import '../../theme';
@import url('//unpkg.com/element-ui@2.15.14/lib/theme-chalk/index.css');
.footer {
  // font-size: 12px;
  padding: 40px 0px 10px 0px;
  background-color: #403a3a;
  color: #a8a8a8;
}
.detailMsg {
  display: flex;
}
.nav,
.contact {
  .title {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  ul {
    li {
      padding: 3px 0px;
      a {
        color: #a8a8a8;
      }
    }
  }
}

.contact {
  .title {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  ul {
    li {
      padding: 3px 0px;
    }
  }
}
.nav {
  margin-left: 10vw;
}
.contact {
  margin-left: 15vw;
}
.info {
  margin-left: 10vw;
  .wx {
    display: flex;
    flex-direction: column;
    img {
      width: 100px;
      height: 100px;
      // margin-bottom: 5px;
    }
    div {
      width: 90px;
      text-align: center;
    }
  }
  .msg {
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.toPrivacyPolicy {
  margin-left: 10vw;
  a {
    color: #a8a8a8;
    cursor: pointer;
  }
}
</style>
